module.exports = __webpack_public_path__ + "media/images/pic/labels/a2_1b-b8acba25c372de2469aa9178b3d171e6.png";